"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Page = require("./Page.context");
var _Page2 = require("./Page.styles");
var _excluded = ["backgroundColor", "fluid", "includeGlobalStyles"];
/**
 * @subcomponents ['PageBreadcrumb', 'PageContent', 'PageTitle']
 * @since 8.15.0
 */
var Page = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var backgroundColor = _ref.backgroundColor,
    fluid = _ref.fluid,
    includeGlobalStyles = _ref.includeGlobalStyles,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var context = {
    fluid: fluid
  };
  return /*#__PURE__*/_react.default.createElement(_Page.PageContext.Provider, {
    value: context
  }, /*#__PURE__*/_react.default.createElement(_Page2.StyledPage, (0, _extends2.default)({
    ref: forwardedRef,
    backgroundColor: backgroundColor
  }, rest)), includeGlobalStyles && /*#__PURE__*/_react.default.createElement(_Page2.PageGlobalStyle, null));
});
exports.Page = Page;
Page.displayName = 'Page';
Page.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A color token or `null`
   * to remove the default background color.
   */
  backgroundColor: _propTypes.default.string,
  /**
   * By default, page components will be bound by the `Page.maxWidth` token.
   * Setting this to true will remove the max width bound.
   *
   * Setting this on `Page` will set `fluid` for all child page components.
   */
  fluid: _propTypes.default.bool,
  /**
   * By default, we include global style to remove the default margins from the `<body>` element.
   * You can disable adding of this global style by setting this to `false`.
   */
  includeGlobalStyles: _propTypes.default.bool
} : {};
Page.defaultProps = {
  includeGlobalStyles: true
};